import { RootDispatch, RootGetState, MessageTemplate, Page } from "../types";
import history from "../../history";
import flash from "../flash/actions";
import { get, post } from "../../utils/fetch";
import { Patient } from "../patient/types";

export type Action =
  | { type: "messagePatient/getPatientLibrary-started" }
  | { type: "messagePatient/getPatientLibrary-success"; messageTemplateList: Page<MessageTemplate> }
  | { type: "messagePatient/getPatientLibrary-failure"; errorMessage: string }
  | { type: "messagePatient/sendUnsecureMessage-started" }
  | { type: "messagePatient/sendUnsecureMessage-success" }
  | { type: "messagePatient/sendUnsecureMessage-failure"; errorMessage: string }
  | { type: "messagePatient/sendSecureMessage-started" }
  | { type: "messagePatient/sendSecureMessage-success" }
  | { type: "messagePatient/sendSecureMessage-failure"; errorMessage: string };

export const getPatientMessageTemplateList = () => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "messagePatient/getPatientLibrary-started"
  });

  const url =
    "/api/organization/" +
    getState().orgs.currentOrganization?.id +
    "/messageTemplates/?type=patient&page_size=9999";

  const resp = await get<Page<MessageTemplate>>(url);

  if (resp.error) {
    dispatch({
      type: "messagePatient/getPatientLibrary-failure",
      errorMessage: resp.error.message
    });
  } else if (resp.data) {
    dispatch({
      type: "messagePatient/getPatientLibrary-success",
      messageTemplateList: resp.data
    });
  } else {
    // TODO logging
  }
};

export const sendUnsecureMessage = (patient: Patient, message: string) => async (
  dispatch: RootDispatch,
  getState: RootGetState
) => {
  dispatch({
    type: "messagePatient/sendUnsecureMessage-started"
  });

  const url = `/api/organization/${getState().orgs.currentOrganization?.id}/patients/${
    patient?.id
  }/sendSmsMessage/`;

  const body = { messageBody: message };

  const resp = await post(url, body);

  if (resp.error) {
    dispatch({
      type: "messagePatient/sendUnsecureMessage-failure",
      errorMessage: resp.error.message
    });
    dispatch(flash("Error sending SMS: " + resp.error.message, "error"));
  } else if (resp.data) {
    dispatch({
      type: "messagePatient/sendUnsecureMessage-success"
    });
    dispatch(
      flash(
        "A SMS message has been sent to " + patient?.givenName + " " + patient?.familyName,
        "info"
      )
    );
    history.goBack();
  } else {
    // Todo logging
  }
};

export const sendSecureMessage = (
  patient: Patient,
  message?: string,
  attachments?: string[]
) => async (dispatch: RootDispatch, getState: RootGetState) => {
  dispatch({
    type: "messagePatient/sendSecureMessage-started"
  });

  const url = `/api/organization/${getState().orgs.currentOrganization?.id}/patients/${
    patient?.id
  }/sendSecureMessage/`;

  const body = { subject: "Secure Message", messageBody: message, attachments: attachments };

  const resp = await post(url, body);

  if (resp.error) {
    dispatch({
      type: "messagePatient/sendSecureMessage-failure",
      errorMessage: resp.error.message
    });
    dispatch(flash("Error sending secure message: " + resp.error.message, "error"));
  } else if (resp.data) {
    dispatch({
      type: "messagePatient/sendSecureMessage-success"
    });
    dispatch(
      flash(
        "A secure message has been sent to " + patient?.givenName + " " + patient?.familyName,
        "info"
      )
    );
    history.goBack();
  } else {
    // Todo logging
  }
};
